import * as types from '@/redux/actionTypes';
import mokaRequest from '@/tools/mokaRequest';
import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

function updateComments(payload) {
  return {
    type: types.UPDATE_COMMENTS,
    payload,
  };
}

function updateAllComments(payload) {
  return {
    type: types.UPDATE_ALL_COMMENTS,
    payload,
  };
}

export function getComment(orgId, applicationId) {
  return (dispatch) => {
    mokaRequest('/api/outer/ats-pipeline/headhunter/headhunterComments', {
      actionName: i18n.t`获取对话`,
      interceptOnError: true,
      query: {
        orgId,
        applicationId,
      },
    })
      .post()
      .then((comments) => {
        const applicationComments = { [applicationId]: { comments, unread: false } };
        dispatch(updateComments(applicationComments));
      });
  };
}

export function getApplicationCommentUnread(orgId) {
  return (dispatch) => {
    mokaRequest('/api/outer/ats-pipeline/headhunter/headhunterUnread', {
      actionName: i18n.t`获取对话`,
      interceptOnError: true,
      query: {
        orgId,
      },
    })
      .post()
      .then((rows) => {
        dispatch(updateAllComments(rows));
      });
  };
}

export function createComment(
  {
    applicationId,
    candidateId,
    isPandect,
    content,
    mentions,
    isPrivate,
    privateType,
    mentionedUserIds,
    orgId,
  },
  callback = () => {}
) {
  return (dispatch) => {
    mokaRequest('/api/outer/ats-pipeline/headhunter/headhunterAdd', {
      interceptOnError: true,
      interceptOnSuccess: true,
      actionName: i18n.t`@HR`,
    })
      .post({
        applicationId,
        candidateId,
        isPandect,
        content,
        mentions,
        isPrivate,
        privateType,
        mentionedUserIds,
        orgId,
      })
      .then((comments) => {
        callback();
        const applicationComments = { [applicationId]: { comments, unread: false } };
        dispatch(updateComments(applicationComments));
      })
      .catch((error) => {
        callback(error);
      });
  };
}
